import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.2/js/sparta-mediaquery-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.0.3/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.1.5/js/sparta-style-utility";
import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
import helpersComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import helperComparisons from "utilities/helpers/helpers-comparisons/1.0.1/js/helpers-comparisons";
import TaglineHelper from "utilities/helpers/helpers-tagline/1.0.0/js/tagline-helper";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import spartaTemplates from "modules/global/global-nav-module/10.0.5/js/templates";
import "css!modules/global/global-nav-module/10.0.5/css/global-nav-module.scss.css";
import "css!modules/global/global-nav-module/10.0.5/css/search-stub-overwrite.scss.css";
import "css!modules/global/global-nav-module/10.0.5/css/menu-nav.scss.css";


const selectors = {
  navigationContainer: '.js-nav-container',
  subNavigationContainer: '.js-sub-nav-container',
  smallSectionTitle: '.js-nav-section-title',
  smallSectionList: '.js-navigation-list-small',
  smallSectionItems: '.js-navigation-item-small',
};

const cssClasses = {
  open: 'navigation__title--open',
  hide: 'hide',
  hideSmall: 'hide-for-small-up',
  hideMediumUp: 'hide-for-medium-up',
  collapsed: 'collapsed',
};

const events = {
  menuButtonClicked: 'GLOBAL_NAV_MODULE_MENU_BUTTON.clicked',
};






class MenuNav {





  init(moduleElement) {
    const sectionTitle = [...moduleElement.querySelectorAll(selectors.smallSectionTitle)];
    sectionTitle.forEach((title) => {
      title.addEventListener('click', this.sectionTitleClick.bind(this));
    });


    moduleElement.addEventListener('transitionend', MenuNav.hideInvisibleContent, false);

    spartaEventsUtility.sub(events.menuButtonClicked, this.toggleNavigation.bind(
      this,
      moduleElement,
    ));
  }






  toggleNavigation(moduleElement) {
    const navigationContainer = moduleElement.querySelector(selectors.navigationContainer);

    requestAnimationFrame(() => {
      navigationContainer.classList.remove(cssClasses.hide);
      requestAnimationFrame(() => {

        navigationContainer.addEventListener('transitionend', function navDoneOnce(e) {
          spartaStickyUtility.recalcStickyEls();


          e.target.removeEventListener(e.type, navDoneOnce);
        });
        navigationContainer.classList.toggle('expanded');
      });
    });
  }







  sectionTitleClick(event) {
    const element = event.currentTarget;
    const section = element.parentElement;
    const sectionList = section.querySelector(selectors.smallSectionList);
    const sectionListItems = [...sectionList.querySelectorAll(selectors.smallSectionItems)];

    element.classList.toggle(cssClasses.open);
    sectionList.classList.remove(cssClasses.hide);

    requestAnimationFrame(() => {
      this.makeAutoHeightExplicitElements({
        targetElement: sectionList,
        referenceElements: sectionListItems,
      });
      sectionList.classList.toggle(cssClasses.collapsed);
    });
    MenuNav.setAriaExpanded({
      referenceElem: sectionList,
      targetElem: element,
      invert: false,
    });
  }













  makeAutoHeightExplicitElements({ targetElement, referenceElements }) {
    let contentHeight = 0;

    referenceElements.forEach((element) => {
      if (element) {
        contentHeight += element.getBoundingClientRect().height;
      }
    });

    if (targetElement) {
      targetElement.style.height = `${contentHeight}px`;
    }
  }







  static hideInvisibleContent(event) {
    const elDimensions = event.target.getBoundingClientRect();
    const hiddenEl = elDimensions.height === 0 || elDimensions.width === 0;

    if (hiddenEl) {
      event.target.classList.add(cssClasses.hide);
    }
  }









  static setAriaExpanded({ referenceElem, targetElem, invert }) {
    MenuNav.syncAttrClass({
      referenceElem,
      targetElem,
      attr: 'aria-expanded',
      className: cssClasses.collapsed,
      invert,
    });
  }













  static syncAttrClass({
    referenceElem,
    targetElem,
    attr,
    className,
    invert,
  }) {
    let attrVal = referenceElem.classList.contains(className);

    if (invert) {
      attrVal = !attrVal;
    }

    targetElem.setAttribute(attr, attrVal);
  }
}

export default new MenuNav();
